import { useQuery } from '@tanstack/react-query'
import { useAuth } from '@clerk/clerk-react'
import { api } from '@/utils/axiosInstances'
import { storage } from '@/helpers'

// TODO: aggregate all queries together
export const CURRENT_USER_QUERY_KEY = ['currentUser'] as const

export interface GameGlassUser {
  id: string
  username: string
  email: string
  [key: string]: unknown
}

export interface CurrentUserData {
  user: GameGlassUser
  token: string
}

export const useCurrentUser = () => {
  const { isSignedIn } = useAuth()

  return useQuery<CurrentUserData>({
    queryKey: CURRENT_USER_QUERY_KEY,
    queryFn: async () => {
      const user = (await api.get<GameGlassUser>('users/@me')).data
      const token = storage.getItem('token') as string
      return { user, token }
    },
    enabled: !!isSignedIn,
    staleTime: Infinity,
  })
}